package com.essntl.features.paymentparameter.ui.addeditpaymentparameter

import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.features.paymentparameter.ui.addeditpaymentparameter.components.PaymentParameterInformation
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography


@Composable
fun AddEditPaymentParameterScreen(
    state: AddEditPaymentParameterState,
    validation: AddEditPaymentParameterValidation,
    onEvent: (AddEditPaymentParameterEvent) -> Unit,
) {
    val isEdit by remember(state.paymentParameter.value.id) {
        mutableStateOf(
            state.paymentParameter.value.id.isNotBlank(),
        )
    }

    var isEditEnabled by remember(state.getPaymentParameter.data?.id) { mutableStateOf(false) }

    LaunchedEffect(state.addEditPaymentParameter.isSuccess) {
        if (state.addEditPaymentParameter.isSuccess) {
            isEditEnabled = false
        }
    }

    LaunchedEffect(state.getPaymentParameter.data) {
        validation.addEditPaymentParameterForm.reset()
        validation.addEditPaymentParameterForm.name.value = state.getPaymentParameter.data?.name.orEmpty()
        validation.addEditPaymentParameterForm.amount.value = state.getPaymentParameter.data?.amount?.toString() ?: ""
    }

    LazyColumn(
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = Modifier
            .fillMaxSize()
            .clip(
                RoundedCornerShape(
                    topStart = 24.dp,
                    topEnd = 24.dp,
                ),
            )
            .padding(
                horizontal = 2.5f.spacing,
            ),
    ) {
        if (
            state.getPaymentParameter.isLoading ||
            state.getPaymentParameter.isFailure ||
            (isEdit && state.getPaymentParameter.data == null)
        )
            item {
                Box(
                    contentAlignment = Alignment.Center,
                    modifier =
                    Modifier
                        .fillMaxWidth()
                        .height(200.dp)
                        .padding(2.5f.spacing)
                        .clip(RoundedCornerShape(EsConstants.RoundedCornerSize)),
                ) {
                    if (state.getPaymentParameter.isLoading) {
                        EsSpinner()
                    } else {
                        Text(
                            text = "Something goes wrong!",
                            color = MaterialTheme.esColorScheme.textSecondary,
                            style = MaterialTheme.esTypography.p1Medium16,
                        )
                    }
                }
            }
        else {
            item {
                PaymentParameterInformation(
                    state = state,
                    validation = validation,
                    onEvent = onEvent,
                    enabled = if (isEdit) isEditEnabled else true,
                )
            }

            item {
                Spacer(modifier = Modifier.height(3.spacing))

                EsLargePrimaryButton(
                    onClick = {
                        if (isEdit && !isEditEnabled) {
                            isEditEnabled = true
                        } else if (validation.addEditPaymentParameterForm.validate()) {
                            if (isEdit) {
                                onEvent(AddEditPaymentParameterEvent.EditPaymentParameter)
                            } else {
                                onEvent(AddEditPaymentParameterEvent.AddPaymentParameter)
                            }
                        }
                    },
                    text =
                    if (isEdit) {
                        if (isEditEnabled) {
                            "Save changes"
                        } else {
                            "Edit"
                        }
                    } else {
                        "Add"
                    },
                    loading = state.addEditPaymentParameter.isLoading,
                    enabled = if (isEditEnabled) state.isEditEnabled else true,
                    modifier = Modifier.fillMaxWidth(),
                )
            }
        }
    }
}